import PartTempoMarker from './PartTempoMarker';

export default PartTempoMarker;
